module.exports = __webpack_public_path__ + "img/facebook.e2a5f137.svg";